/**
 * 资源管理相关
 */
import axios from '../../utils/axios'
import adminAaxios from "../../utils/axios";
export function update_daily_budget(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/update_daily_budget",
        method: "POST",
        data: data
    });
}
// 添加广告优化逻辑层解析数据
export function addLogic_prevent_bidding(data) {
    return adminAaxios({
        url: "admin/advertising/logic_prevent_bidding/add",
        method: "POST",
        data: data
    });
}
// 解析数据
export function getAdBetterList(data) {
    return adminAaxios({
        url: "admin/advertising/logic_prevent_bidding/index",
        method: "POST",
        data: data
    });
}
// 广告优化-解析文件
export function getAdBetterFile(data) {
    return adminAaxios({
        url:
            "/admin/advertising/logic_prevent_bidding/parsing_prevent_bidding_file",
        method: "POST",
        data: data
    });
}

// 解析数据
export function get_parse_status(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/get_parse_status",
        method: "POST",
        data: data
    });
}
// 前置否定解析
export function parsing_predisavowal_file(data) {
    return adminAaxios({
        url: "/admin/advertising/predisavowal/parsing_predisavowal_file",
        method: "POST",
        data: data
    });
}
// 运营解析
export function parsing_ad_expenses_file(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_expenses/parsing_ad_expenses_file",
        method: "POST",
        data: data
    });
}
export function parsing_prevent_bidding_file(data) {
    return adminAaxios({
        url: "/admin/advertising/prevent_bidding/parsing_prevent_bidding_file",
        method: "POST",
        data: data
    });
}
export function parsing_apollo_file(data) {
    return adminAaxios({
        url: "/admin/advertising/apollo/parsing_apollo_file",
        method: "POST",
        data: data
    });
}
// 获取广告基础信息
export function get_ad_base_group_message(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/get_ad_base_group_message",
        method: "POST",
        data: data
    });
}
// 获取广告基础信息
export function add_ad_base_group_message(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/add_ad_base_group_message",
        method: "POST",
        data: data
    });
}
// 广告数据上传
export function getAdData(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/index",
        method: "POST",
        data: data
    });
}
// 删除广告数据记录删除
export function ad_data_delete(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/delete",
        method: "POST",
        data: data
    });
}

// 上传广告数据文件
export function new_ad_data_add(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/upload_source_file",
        method: "POST",
        data: data
    });
}
// 获取合理分析列表
export function get_rationality_analysis(data) {
    return adminAaxios({
        url: "/admin/advertising/rationality_analysis/index",
        method: "POST",
        data: data
    });
}
// 添加合理分析列表
export function add_rationality_analysis(data) {
    return adminAaxios({
        url: "/admin/advertising/rationality_analysis/add",
        method: "POST",
        data: data
    });
}
// 编辑合理分析列表
export function edit_rationality_analysis(data) {
    return adminAaxios({
        url: "/admin/advertising/rationality_analysis/index",
        method: "POST",
        data: data
    });
}
// 删除合理分析列表
export function delete_rationality_analysis(data) {
    return adminAaxios({
        url: "/admin/advertising/rationality_analysis/delete",
        method: "POST",
        data: data
    });
}
// 解析分析
export function parse_rationality_analysis(data) {
    return adminAaxios({
        url:
            "/admin/advertising/rationality_analysis/parsing_rationality_analysis_file",
        method: "POST",
        data: data
    });
}
// 获取数据趋势列表
export function get_data_trend(data) {
    return adminAaxios({
        url: "/admin/advertising/data_trend/index",
        method: "POST",
        data: data
    });
}
// 添加数据趋势列表
export function add_data_trend(data) {
    return adminAaxios({
        url: "/admin/advertising/data_trend/add",
        method: "POST",
        data: data
    });
}
// 删除数据趋势列表
export function delete_data_trend(data) {
    return adminAaxios({
        url: "/admin/advertising/data_trend/delete",
        method: "POST",
        data: data
    });
}
// 解析分析
export function parse_data_trend(data) {
    return adminAaxios({
        url:
            "/admin/advertising/data_trend/parsing_data_trend_file",
        method: "POST",
        data: data
    });
}

// 获取单线程列表
export function get_single_threaded_structure(data) {
    return adminAaxios({
        url: "/admin/advertising/single_threaded_structure/index",
        method: "POST",
        data: data
    });
}
// 添加单线程数据
export function add_single_threaded_structure(data) {
    return adminAaxios({
        url: "/admin/advertising/single_threaded_structure/add",
        method: "POST",
        data: data
    });
}
// 删除单线程数据
export function delete_single_threaded_structure(data) {
    return adminAaxios({
        url: "/admin/advertising/single_threaded_structure/delete",
        method: "POST",
        data: data
    });
}
// 解析分析
export function parse_single_threaded_structure(data) {
    return adminAaxios({
        url: "/admin/advertising/single_threaded_structure/parsing_single_threaded_structure_file",
        method: "POST",
        data: data
    });
}


// listing详情数据展示
export function listing_detail_show(data) {
    return axios({
        url: "/apis/seed_word/listing_detail_show",
        method: "POST",
        data: data
    });
}
// 一段时间数据导出
export function seed_keyword_file_export_period(data) {
    return axios({
        url: "/apis/period_seed_word/seed_keyword_file_export_period",
        method: "POST",
        data: data
    });
}
// 一段时间数据展示
export function period_seed_word_show(data) {
    return axios({
        url: "/apis/period_seed_word/period_seed_keyword_show",
        method: "POST",
        data: data
    });
}
// 一段时间数据删除
export function period_seed_keyword_record_delete(data) {
    return axios({
        url: "/apis/period_seed_word/period_seed_keyword_record_delete",
        method: "POST",
        data: data
    });
}
// 一段时间 asin 数据导出
export function asin_keyword_file_export_period(data) {
    return axios({
        url: "/apis/period_seed_word/asin_keyword_file_export_period",
        method: "POST",
        data: data
    });
}
// 一段时间 asin 数据展示
export function period_asin_keyword_show(data) {
    return axios({
        url: "/apis/period_seed_word/period_asin_keyword_show",
        method: "POST",
        data: data
    });
}
// 一段时间 asin 数据删除
export function period_asin_keyword_record_delete(data) {
    return axios({
        url: "/apis/period_seed_word/period_asin_keyword_record_delete",
        method: "POST",
        data: data
    });
}

// listing的广告数据记录展示
export function listing_ad_data_show(data) {
    return axios({
        url: "/apis/seed_word/listing_ad_data_show",
        method: "POST",
        data: data
    });
}

// 防止内竞价展示展示
export function prevent_internal_competition_logic_show(data) {
    return axios({
        url: "apis/open_ad_group/prevent_internal_competition_logic_show",
        method: "POST",
        data: data
    });
}
// 可选关联防内部竞价(逻辑层面)
export function prevent_internal_competition_logic_analysis_by_relevance(data) {
    return axios({
        url:
            "/apis/open_ad_group/prevent_internal_competition_logic_analysis_by_relevance",
        method: "POST",
        data: data
    });
}

// 上传lingsting广告数据文件
export function listing_ad_data_add(obj, data) {
    return axios({
        url: "/apis/open_ad_group/listing_ad_data_add",
        method: "POST",
        params: obj,
        data: data
    });
}

// lingsting广告数据记录删除
export function listing_ad_data_delete(data) {
    return axios({
        url: "/apis/open_ad_group/listing_ad_data_delete",
        method: "POST",
        data: data
    });
}

// 防内部竞价(逻辑层面)
export function listing_prevent_internal_competition(data) {
    return axios({
        url: "/apis/open_ad_group/listing_prevent_internal_competition",
        method: "POST",
        data: data
    });
}

// 品牌竞价
export function check_brand_ppc(data) {
    return axios({
        url: "/apis/open_ad_group/check_brand_ppc",
        method: "POST",
        data: data
    });
}

// 任务列表
export function listing_tasking_detail(data) {
    return axios({
        url: "/apis/v1/listing_tasking_detail",
        method: "POST",
        data: data
    });
}

// 广告优化记录展示
export function ppc_optimize_show(data) {
    return axios({
        url: "/apis/seed_word/ppc_optimize_show",
        method: "POST",
        data: data
    });
}

// 广告优化记录添加
export function ppc_optimize_add(data) {
    return axios({
        url: "/apis/open_ad_group/ppc_optimize_add",
        method: "POST",
        data: data
    });
}

// 广告优化记录删除
export function ppc_optimize_delete(data) {
    return axios({
        url: "/apis/open_ad_group/ppc_optimize_delete",
        method: "POST",
        data: data
    });
}

// 降bid列表
export function reduce_bid_index(data) {
    return adminAaxios({
        url: "/admin/advertising/reduce_bid/index",
        method: "POST",
        data: data
    });
}
// 降bid列表-删除
export function reduce_bid_delete(data) {
    return adminAaxios({
        url: "/admin/advertising/reduce_bid/delete",
        method: "POST",
        data: data
    });
}
// 降bid列表-添加
export function reduce_bid_add(data) {
    return adminAaxios({
        url: "/admin/advertising/reduce_bid/add",
        method: "POST",
        data: data
    });
}

// 降bid列表-解析
export function reduce_bid_parsing_file(data) {
    return adminAaxios({
        url: "/admin/advertising/reduce_bid/parsing_file",
        method: "POST",
        data: data
    });
}


// 添加默认ACOS
export function add_ad_default_acos(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/add_ad_default_acos",
        method: "POST",
        data: data
    });
}


// 获取默认ACOS
export function get_ad_default_acos(data) {
    return adminAaxios({
        url: "/admin/advertising/ad_data/get_ad_default_acos",
        method: "POST",
        data: data
    });
}



// 上传预算控制源文件
export function budget_control_upload(data) {
    return adminAaxios({
        url: "/admin/advertising/budget/upload_source_file",
        method: "POST",
        data: data
    });
}
// 预算控制列表
export function budget_control_list(data) {
    return adminAaxios({
        url: "/admin/advertising/budget/index",
        method: "POST",
        data: data
    });
}
// 添加单条预算控制记录
export function budget_control_add(data) {
    return adminAaxios({
        url: "/admin/advertising/budget/add",
        method: "POST",
        data: data
    });
}
// 删除单条预算控制记录
export function budget_control_del(data) {
    return adminAaxios({
        url: "/admin/advertising/budget/delete",
        method: "POST",
        data: data
    });
}
// 预算控制 - 解析文件
export function budget_control_parse(data) {
    return adminAaxios({
        url: "/admin/advertising/budget/parsing_file",
        method: "POST",
        data: data
    });
}

// 获取广告活动报告更新日期
export function advertising_budget_get_duration_date(data) {
    return adminAaxios({
        url: "/admin/advertising/budget/get_duration_date",
        method: "POST",
        data: data
    });
}




// 获取默认Acos
export function sb_ad_data_get_ad_default_acos(data) {
    return adminAaxios({
        url: "/admin/ad_for_sb/sb_ad_data/get_ad_default_acos",
        method: "POST",
        data: data
    });
}
// 添加默认Acos
export function sb_ad_data_add_ad_default_acos(data) {
    return adminAaxios({
        url: "/admin/ad_for_sb/sb_ad_data/add_ad_default_acos",
        method: "POST",
        data: data
    });
}



// 获取广告组基础信息
export function sb_ad_data_get_ad_base_group_message(data) {
    return adminAaxios({
        url: "/admin/ad_for_sb/sb_ad_data/get_ad_base_group_message",
        method: "POST",
        data: data
    });
}
// 添加广告组信息
export function sb_ad_data_add_ad_base_group_message(data) {
    return adminAaxios({
        url: "/admin/ad_for_sb/sb_ad_data/add_ad_base_group_message",
        method: "POST",
        data: data
    });
}
// 修改日耗信息
export function sb_ad_data_update_daily_budget(data) {
    return adminAaxios({
        url: "/admin/ad_for_sb/sb_ad_data/update_daily_budget",
        method: "POST",
        data: data
    });
}
// 删除单条记录
export function sb_ad_data_delete(data) {
    return adminAaxios({
        url: "/admin/ad_for_sb/sb_ad_data/delete",
        method: "POST",
        data: data
    });
}
// 列表
export function sb_ad_data_index(data) {
    return adminAaxios({
        url: "/admin/ad_for_sb/sb_ad_data/index",
        method: "POST",
        data: data
    });
}
// 上传源文件
export function sb_ad_data_upload_source_file(data) {
    return adminAaxios({
        url: "/admin/ad_for_sb/sb_ad_data/upload_source_file",
        method: "POST",
        data: data
    });
}


// Sp广告-单线程结构
export function single_threaded_structure_index(data) {
    return adminAaxios({
        url: "/admin/ad_for_sp/single_threaded_structure/index",
        method: "POST",
        data: data
    });
}
export function single_threaded_structure_add(data) {
    return adminAaxios({
        url: "/admin/ad_for_sp/single_threaded_structure/add",
        method: "POST",
        data: data
    });
}
export function single_threaded_structure_parse(data) {
    return adminAaxios({
        url: "/admin/ad_for_sp/single_threaded_structure/parse",
        method: "POST",
        data: data
    });
}
export function single_threaded_structure_delete(data) {
    return adminAaxios({
        url: "/admin/ad_for_sp/single_threaded_structure/deleted",
        method: "POST",
        data: data
    });
}

export function base_get_sp_ad_extra_config(data) {
    return adminAaxios({
        url: "/admin/ad_for_sp/base/get_sp_ad_extra_config",
        method: "POST",
        data: data
    });
}
export function base_set_sp_ad_extra_config(data) {
    return adminAaxios({
        url: "/admin/ad_for_sp/base/set_sp_ad_extra_config",
        method: "POST",
        data: data
    });
}


export function single_threaded_structure_get_campaign_list(data) {
    return adminAaxios({
        url: "/admin/ad_for_sp/single_threaded_structure/get_campaign_list",
        method: "POST",
        data: data
    });
}

